import { format } from 'date-fns/format';
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';
import { isFuture } from 'date-fns/isFuture';

export const timeDifference = (time) => formatDistanceToNow(new Date(time), { addSuffix: true });
export const dayOfWeek = (time) => format(new Date(time), 'iiii');
export const monthDayYear = (time) => format(new Date(time), 'MMM dd, yyyy');
export const isFutureDate = (time) => isFuture(new Date(time));
